module.exports = __webpack_public_path__ + "static/media/banner_JORNADAcereales.72ba5196.jpg";